import React from 'react';

import {Route,Routes} from "react-router-dom";
import ExerciseDetails from './Pages/ExerciseDetails';
import Home from './Pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';
import { Box } from '@mui/material';


const App = () => {
  return (
    <Box width = "400px" sx={{width:{x1:"1488px"}}} m = "auto">
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>}></Route>
        <Route path="/exercise/:id" element={<ExerciseDetails/>}/>
      </Routes>
      <Footer/>
    </Box>
    
  )
}





export default App;
